<template>
  <div class="-wrapper-column h-center- -height-100 -px-10 -py-10">
    <div class="login-logo-wrap -wrapper-v-center -width-100">
      <img src="/assets/images/logo_header.jpg" alt="Ops Now" />
    </div>
    <div class="login-cont-wrap -wrapper -wrapper-v-h-center">
      <div class="login-wrap s3 -wrapper nowrap-">
        <div class="form-wrap -font-size-12">
          <h1 class="-h1 -mb-2 -font-size-32 -font-weight-medium text-center-" id="terms-agreement-title">{{$t('pages_terms_TermsAgreement.1')}}</h1>
          <p class="-mb-10 -font-size-14 -color-gray-1 text-center-" id="terms-agreement-description">
            {{$t('pages_terms_TermsAgreement.2')}}
          </p>

          <div class="-label -width-100 -pb-8">
            <div class="-wrapper -mb-2">
              <g-checkbox :text="$t('pages_terms_TermsAgreement.checkbox.1')" @change="onChangeTermServiceCheckbox" value="privacyPolicy" :checked="isCheckedTermService"
                id="terms-agreement-checkbox-01"
              />
            </div>
            <div class="-width-100 -border -font-size-14 -color-gray-1 -border-radius-1" style="height: 200px;"
              id="terms-agreement-privacy-policy-iframe-container"
            >
              <iframe src="about:blank" ref="activePrivacyPolicy" style="width: 100%; height: 100%; board: 0;"
                id="terms-agreement-privacy-policy-iframe" title="activePrivacyPolicy"></iframe>
            </div>
          </div>

          <div class="-label -width-100 -pb-8">
            <div class="-wrapper -mb-2">
              <g-checkbox :text="$t('pages_terms_TermsAgreement.checkbox.2')" @change="onChangePrivacyPolicyCheckbox" value="agreement" :checked="isCheckedPrivacyPolicy"
                id="terms-agreement-checkbox-02"
              />
            </div>
            <div class="-width-100 -border -font-size-14 -color-gray-1 -border-radius-1" style="height: 200px;"
              id="terms-agreement-terms-iframe-container"
            >
              <iframe src="about:blank" ref="privacyPolicy" style="width: 100%; height: 100%; board: 0;"
                id="terms-agreement-terms-iframe" title="privacyPolicy"></iframe>
            </div>
          </div>

          <div class="-label -width-100 -pb-8 -pt-2 -border-top">
            <div class="-wrapper">
              <g-checkbox :text="$t('pages_terms_TermsAgreement.checkbox.3')" value="allCheck" :checked="isCheckedAll" @change="onChangeAllClick"
                id="terms-agreement-check-all"
              />
            </div>
          </div>

          <div class="-label -wrapper h-center- -width-100 -pb-2">
            <g-button variant="primary" @click="onClickAgreeBtn" :disabled="!isCheckedAll"
              id="terms-agreement-agree-button"
            >
              <span id="terms-agreement-agree-button-text">{{$t('common.agree')}}</span>
            </g-button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CodeUpdate from '@/code/CodeUpdate'

export default {
  data () {
    return {
      isCheckedTermService: false,
      isCheckedPrivacyPolicy: false,
    }
  },
  computed: {
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('terms', ['activePrivacyPolicy', 'agreementFirst', 'codeTermAccept']),
    isCheckedAll () {
      return this.isCheckedTermService && this.isCheckedPrivacyPolicy;
    }
  },
  methods: {
    ...mapActions('terms', ['getAllTerms', 'acceptTerms', 'acceptedAgreement']),
    onChangePrivacyPolicyCheckbox (e) {
      this.isCheckedPrivacyPolicy = !this.isCheckedPrivacyPolicy
    },
    onChangeTermServiceCheckbox (e) {
      this.isCheckedTermService = !this.isCheckedTermService
    },
    onChangeAllClick (e) {
      const checked = !this.isCheckedAll
      this.isCheckedTermService = checked;
      this.isCheckedPrivacyPolicy = checked;
    },
    onClickAgreeBtn () {
      if (this.isCheckedAll) {
        this.acceptTerms({acceptTermList: [this.activePrivacyPolicy, this.agreementFirst]})
      }
    },
    // onClickDisagreeBtn () {
    //   window.keycloak.logout()
    // }
  },
  watch: {
    codeTermAccept: {
      handler () {
        if (this.codeTermAccept === CodeUpdate.SUCCESS) {
          this.acceptedAgreement()
          if (this.userInfo.passwordChangeDate === 'N') {
            this.$router.push('/login/reset-password')
          } else {
            this.$router.push('/home')
          }
        }
      }
    },
    agreementFirst () {
      this.$refs.privacyPolicy.contentDocument.body.innerHTML = this.agreementFirst.terms
    },
    activePrivacyPolicy () {
      this.$refs.activePrivacyPolicy.contentDocument.body.innerHTML = this.activePrivacyPolicy.terms
    }
  },
  beforeMount () {
    this.getAllTerms();
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/terms/TermsAgreement.vue